import { r as registerInstance, c as createEvent, h, F as Fragment } from './index-d4808923.js';
import { b as bem } from './index.esm-7182addc.js';

const gravitySplitButtonCss = ":host{display:inline-block;max-width:100%}:host([width=full-width]){width:100%}.gravity-split-button{display:flex;max-width:100%}.gravity-split-button__left{--gravity-button-border-radius:9999px 0 0 9999px;--gravity-button-padding:0 12px 0 16px;--gravity-button-min-width:0;--gravity-button-border-right:1px solid rgba(0, 15, 30, 0.2);min-width:0}.gravity-split-button--busy .gravity-split-button__left{position:relative}.gravity-split-button__right{--gravity-button-border-radius:0 9999px 9999px 0;--gravity-button-padding:0 12px 0 8px;--gravity-button-min-width:0}.gravity-split-button--busy .gravity-split-button__left,.gravity-split-button--busy .gravity-split-button__right{cursor:default}.gravity-split-button--width-full-width{width:100%}.gravity-split-button__label{display:flex;gap:4px}.gravity-split-button--busy .gravity-split-button__label{visibility:hidden}.gravity-split-button__loading{left:50%;opacity:0.4;position:absolute;top:50%;transform:translate(-50%, -50%)}.gravity-split-button--disabled .gravity-split-button__left{--gravity-button-border-right:1px solid rgba(0, 15, 30, 0.05)}.gravity-split-button--type-secondary .gravity-split-button__right{margin-left:-1px}";
const GravitySplitButtonStyle0 = gravitySplitButtonCss;

const GravitySplitButton = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.actionClicked = createEvent(this, "actionClicked", 7);
        this.generateClassNames = bem('gravity-split-button');
        this.handleDropdownActionClicked = (event) => {
            const id = event.detail[0];
            this.actionClicked.emit({ id });
        };
        this.handleButtonActionClicked = (event) => {
            event.stopPropagation();
            const id = this.actions[0].id;
            this.actionClicked.emit({ id });
        };
        this.getTextColor = () => {
            if (this.disabled || this.busy) {
                return this.mode === 'dark' ? 'dark-muted' : 'light-muted';
            }
            if (this.mode === 'dark') {
                return this.type === 'primary' ? 'light' : 'dark';
            }
            return 'light';
        };
        this.actions = [];
        this.busy = false;
        this.disabled = false;
        this.mode = 'dark';
        this.size = undefined;
        this.type = 'primary';
        this.width = 'auto';
        this.dropdownOptions = [];
    }
    actionsChanged() {
        this.mapActionsToDropdownOptions();
    }
    mapActionsToDropdownOptions() {
        this.dropdownOptions = this.actions.slice(1).map((action) => ({
            id: action.id,
            label: action.label,
            disabled: action.disabled,
            prefix: `<gravity-icon name="${action.iconName}"></gravity-icon>`,
        }));
    }
    componentWillLoad() {
        this.mapActionsToDropdownOptions();
    }
    render() {
        var _a, _b, _c;
        return (h(Fragment, { key: 'c79b01eee13e9412800e62774cdb9a0bdeaaea1a' }, h("div", { key: '612a36cc9717e12b321ad2d5caddb09265981cce', class: this.generateClassNames({
                size: this.size,
                disabled: this.disabled,
                width: this.width,
                busy: this.busy,
                type: this.type,
                mode: this.mode,
            }), id: "dropdown-anchor" }, h("gravity-button", { key: '80f45e8cd52a4ec1aaee76bb7ae878f67590d675', class: this.generateClassNames('left'), size: this.size, disabled: this.disabled || this.busy, width: this.width, onClick: this.handleButtonActionClicked, type: this.type, mode: this.mode }, h("span", { key: 'c5a2802248ff62888e48141d8b5a03cc69c8cfc3', class: this.generateClassNames('label') }, ((_a = this.actions[0]) === null || _a === void 0 ? void 0 : _a.iconName) && (h("gravity-icon", { key: 'faa425ab4bfda04fe3b7d79548ccaa5f92e02ee8', color: this.getTextColor(), name: (_b = this.actions[0]) === null || _b === void 0 ? void 0 : _b.iconName })), (_c = this.actions[0]) === null || _c === void 0 ? void 0 :
            _c.label), this.busy && (h("gravity-loading", { key: '90ebea29107d7b136e079653390d33df9b84fb36', class: this.generateClassNames('loading'), variant: this.mode == 'light' ? 'light' : 'secondary' }))), h("gravity-button", { key: '9bb6f6b3cb3c81817f8204a73e88498fb367a722', id: "dropdown-button", class: this.generateClassNames('right'), disabled: this.disabled || this.busy, size: this.size, type: this.type, mode: this.mode }, h("gravity-icon-arrow-down-outline", { key: '6092da00136064510921611bfb2436eb8ea72844', slot: "icon", size: this.size == 'medium' ? 'xx-small' : 'xxx-small', color: this.getTextColor() }))), h("gravity-dropdown", { key: '1dbb737226ec0bac0c826aa7ee5291308ab42aaf', class: this.generateClassNames('dropdown'), for: "dropdown-button", options: this.dropdownOptions, selectionBehavior: false, size: this.size, flipBottom: true, position: "right", positionStrategy: "fixed", onDropdownOptionSelected: this.handleDropdownActionClicked, anchor: "dropdown-anchor" })));
    }
    static get watchers() { return {
        "actions": ["actionsChanged"]
    }; }
};
GravitySplitButton.style = GravitySplitButtonStyle0;

export { GravitySplitButton as gravity_split_button };

//# sourceMappingURL=gravity-split-button.entry.js.map